<div class="image-cropper-modal" (click)="close()">
    <div class="inner" (click)="$event.stopImmediatePropagation()">
        <div class="cropper-canvas">
            <image-cropper [imageChangedEvent]="imageChangedEvent" [imageFile]="imageFile" [maintainAspectRatio]="true"
                [aspectRatio]="aspect" format="png" (imageCropped)="imageCropped($event)" [roundCropper]="roundCropper"
                (imageLoaded)="imageLoaded( $event )" (cropperReady)="cropperReady()"  output="base64"
                (loadImageFailed)="loadImageFailed()"></image-cropper>
        </div>

        <div class="cropper-footer d-flex w-100 justify-content-center align-items-center">
            <sketch-icon-button text="Close" size="large" type="close" (click)="close( )" class="mr-2"></sketch-icon-button>

            <sketch-icon-button text="Crop" size="large"  (click)="doCrop( )" class="ml-2"></sketch-icon-button>

        </div>
    </div>
</div>